import { TaskStatusInfo } from '@euler/model';
import { useCreation } from '@euler/utils/hooks';
import { createContext, memo, ReactNode, useContext, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';

export type TaskStateTrackingContextProps = {
  statusChanges$: BehaviorSubject<Map<string, TaskStatusInfo>>;
};

export const TaskStateTrackingContext =
  createContext<TaskStateTrackingContextProps>(null as any);

export const useTaskStateTrackingContext = () => {
  return useContext(TaskStateTrackingContext);
};

export const TaskStateTrackingProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    const statusChanges$ = useCreation(
      () => new BehaviorSubject(new Map<string, TaskStatusInfo>()),
      [],
    );
    const value = useMemo(() => ({ statusChanges$ }), [statusChanges$]);
    return (
      <TaskStateTrackingContext.Provider value={value}>
        {children}
      </TaskStateTrackingContext.Provider>
    );
  },
);
